import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ModalRightService } from '../../../../../services/modal-right/modal-right.service';
import { ParametreDocumentStateService } from '../../../../../services/parametre-document/parametre-document-state.service';
import {
    getVenteDocumentTypeLabel,
    PARAMETRE_TYPE_DOCUMENT_VENTE
} from '../../../../../services/parametre-document/parametre-document-type-ids';
import { VenteAchatParametreRow } from '../../../../../services/parametre-document/parametre-document-settings.service';
import {
    DEFAULT_HEX_COLOR,
    isTruthyTinyInt,
    toHexColorInputValue
} from '../../../../../services/parametre-document/parametre-doc-api-normalize';

@Component({
    selector: 'app-doc-vente-bon-sortie',
    templateUrl: './doc-vente-bon-sortie.component.html',
    styleUrls: ['./doc-vente-bon-sortie.component.scss']
})
export class DocVenteBonSortieComponent implements OnInit {
    saving = false;
    private readonly typeId = PARAMETRE_TYPE_DOCUMENT_VENTE.bonSortie;

    readonly documentTypeLabel = getVenteDocumentTypeLabel(this.typeId);

    labelText = this.documentTypeLabel;

    couleurText = DEFAULT_HEX_COLOR;

    affMontantTotaux = false;
    affInfContact = false;
    affCourteDesp = false;
    affInfos = false;
    noteText = '';

    constructor(
        private customizerService: ModalRightService,
        private state: ParametreDocumentStateService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.state.ensureLoaded().subscribe({
            next: () => this.applyRowFromState(),
            error: () => this.toastr.error('Impossible de charger les paramètres.', 'Erreur')
        });
    }

    private applyRowFromState(): void {
        const row = this.state.getRowForType(this.typeId);
        if (row == null) {
            this.applyDefaultsSansDonneesApi();
            return;
        }
        this.labelText = row.label?.trim() || this.documentTypeLabel;
        this.couleurText = toHexColorInputValue(row.couleur);
        this.affMontantTotaux = isTruthyTinyInt(row.aff_montant_totaux);
        this.affInfContact = isTruthyTinyInt(row.aff_inf_contact);
        this.affCourteDesp = isTruthyTinyInt(row.aff_courte_desp);
        this.affInfos = isTruthyTinyInt(row.aff_num_bn_liv);
        this.noteText = row.note ?? '';
    }

    private applyDefaultsSansDonneesApi(): void {
        this.labelText = this.documentTypeLabel;
        this.couleurText = toHexColorInputValue('');
        this.affMontantTotaux = false;
        this.affInfContact = false;
        this.affCourteDesp = false;
        this.affInfos = false;
        this.noteText = '';
    }

    private buildPatch(): Partial<VenteAchatParametreRow> {
        return {
            label: this.labelText?.trim() || null,
            couleur: this.couleurText || null,
            aff_montant_totaux: this.affMontantTotaux ? 1 : 0,
            aff_inf_contact: this.affInfContact ? 1 : 0,
            aff_courte_desp: this.affCourteDesp ? 1 : 0,
            aff_num_bn_liv: this.affInfos ? 1 : 0,
            note: this.noteText || null
        };
    }

    saveParametreDocument(): void {
        this.saving = true;
        this.state
            .saveWithVenteAchatPatch(this.typeId, 'vente', this.buildPatch())
            .pipe(finalize(() => (this.saving = false)))
            .subscribe({
                next: () => this.toastr.success('Paramètres enregistrés.', 'Succès'),
                error: (err) => {
                    const msg = err?.error?.message ?? err?.message ?? 'Erreur serveur';
                    this.toastr.error(msg, 'Enregistrement');
                }
            });
    }

    appercue(): void {
        this.customizerService.open();
    }
}
